module.exports = __webpack_public_path__ + "static/media/sevac.f2ec085d.jpeg";